<template>
    <select
        id="dealing_rep_id"
        name="dealing_rep_id"
        class="form-control"
        v-model="dr"
        :disabled="disabled"
    >
        <option value="" selected="selected">-- Select One --</option>
        <option v-for="option in computedOptions" v-bind:value="option.value">
            {{ option.label }}
        </option>
    </select>
</template>

<script>

  import axios from 'axios'

  export default {
    props: ['initialDr', 'initialRegion', 'initialReps', 'emd', 'initialDisabled'],
    data() {
      return {
        reps: [],
        dr: '',
        region: this.initialRegion,
        disabled: this.initialDisabled
      }
    },
    computed: {
      computedOptions() {
        let options = [
          {label: `I don't have a ${this.emd} representative.`, value: 'no_rep'}
        ]

        this.reps.forEach(rep => {
          options.push({label: rep.name, value: rep.id})
        })

        return options
      }
    },
    methods: {
      addDealingReps(reps) {
        let temp = []
          _.each(reps,function (data) {
               temp.push(data)
		  })

        this.reps = temp
      },
      updateDealingReps() {
        this.disabled = true
        if (this.region) {
          return axios.get(`available-dealing-reps/${this.region}`)
            .then(response => {
              this.addDealingReps(response.data)
              return Promise.resolve()
            })
        } else {
          this.addDealingReps([])
          return Promise.resolve()
        }
      },
      onRegionChanged(region) {
        this.region = region;
        this.updateDealingReps().then(() => {
          this.disabled = false
        });
        this.dr = '';
      }
    },
    created() {
      this.region = this.initialRegion;
      this.updateDealingReps().then(() => {
        this.disabled = this.initialDisabled;
        this.dr = this.region ? this.initialDr : '';
      });
      this.disabled = this.initialDisabled;
      this.dr = this.region ? this.initialDr : '';
      this.$root.$on('regionChanged', this.onRegionChanged);
    },
    events: {
      regionChanged(region) {
        this.region = region
        this.updateDealingReps().then(() => {
          this.disabled = false
        });
        this.dr = '';
      }
    },
  }
</script>
